<template>
  <el-popover
    v-if="isCatProp"
    trigger="focus"
    placement="top"
    :disabled="!hasTips"
    >
    <span
      style="display: block"
      v-for="(tip, tipIndex) in tips"
      v-html="tip"
      :key="tipIndex"></span>
    <el-input
      slot="reference"
      v-bind="props"
      :value="_value"
      @input="onInput"
      @blur="onBlur"></el-input>
  </el-popover>
  <el-input
    v-else
    v-bind="props"
    :value="_value"
    @input="onInput"
    @blur="onBlur">
    <template v-if="props.append" slot="append">{{ props.append }}</template>
    <span v-if="showWordLimit" slot="suffix" style="margin-right: 6px;">{{ inputLength }}/{{ props.maxLengthRule}}</span>
  </el-input>
</template>

<script>
import storeMixins from '../store-mixins'
import { checkLength } from '../../utils/index'

export default {
  mixins: [storeMixins],
  props: ["props", "tipRule", "value", "isMultiComlexItem", 'emitUpdate'],
  computed: {
    key() {
      return this.props.name
    },
    tips() {
      return this.tipRule || []
    },
    hasTips() {
      return this.tips.length
    },
    isCatProp() {
      return this.props.parentName === 'catProp'
    },
    _value() {
      if (this.isMultiComlexItem || this.emitUpdate) {
        return this.value
      }
      return this.tbForm[this.key]
    },
    showWordLimit() {
      return ['title'].includes(this.key) && this.props?.maxLengthRule
    },
    inputLength() {
      return checkLength(this._value)
    }
  },
  methods: {
    onInput(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v)
      }
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateForm(newFormFields)
    },
    onBlur(v) {
      // 一口价失焦判断
      this.$emit('blur', v, this.key)
    },
    updateForm(valueObj) {
      if (this.emitUpdate) {
        this.$emit('change', valueObj);
      } else {
        this.updateTbForm(valueObj);
      }
    },
  },
  mounted() {
   
  }
}
</script>

<style></style>